import { HStack, Text } from '@chakra-ui/react';
import { useAppSelector } from '@hooks/redux.hooks';
import { hasRole } from '@redux/authent/authent.selectors';
import { RootState } from '@redux/store';

import { RoleEnum } from '@/types/authent/roles.types';

import PlatformsButton from './platform/PlatformsButton';

type Props = {
  label: string;
  hideCommonButton?: boolean;
};

export default function CockpitPanelHeader({ label, hideCommonButton = false }: Readonly<Props>) {
  const canAccessPlatform = useAppSelector((state: RootState) => hasRole(state, RoleEnum.ACCESS_PLATFORM));

  return (
    <HStack height="56px" width="100%" paddingLeft={2} backgroundColor="neutral.800-op70" gap={0}>
      <Text fontWeight="medium" color="neutral.200" textTransform="uppercase" flex={1} userSelect="none">
        {label}
      </Text>
      {!hideCommonButton && (
        <HStack gap={0} marginLeft="auto" height="56px">
          {canAccessPlatform && <PlatformsButton />}
        </HStack>
      )}
    </HStack>
  );
}
